import { $ } from 'venuescanner-js/tools/elemental';
import moment from 'moment';

const APP_ID = 'd3unjwbo';

const attachIntercom = () => {
  // eslint-disable-next-line
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
};

export const setupIntercom = () => {
  window.moment = moment;
  if (window.data.user && window.data.user.email) {
    window.intercomSettings = {
      app_id: 'd3unjwbo',
      name: window.data.user.name,
      email: window.data.user.email,
      created_at: moment(window.data.user.joined) * 1,
    };
  } else {
    window.intercomSettings = {
      app_id: APP_ID,
    };
  }

  const isMobile = window.innerWidth < 1200;
  const baseShowCondition =
    $('.notawk').get().length === 0 ||
    (!isMobile && document.body.dataset.path === 'inbox_index');

  const mobileDisabledPages = ['sdp_sdp'];
  const isMobileDisabledPage =
    isMobile && mobileDisabledPages.includes(document.body.dataset.path);

  const shouldShowBeacon = baseShowCondition && !isMobileDisabledPage;

  // Note: this disable intercom only on page load, is not listening to the resize event
  if (shouldShowBeacon) attachIntercom();
};
